<template>
  <div class="box">
    <v-server-table
      ref="datatable"
      :url="api"
      :name="tableName"
      :columns="columns"
      :options="options">

      <template
        slot="code"
        slot-scope="props">
        <i
          v-if="props.row.code == null"
          class="text-muted">Empty</i>
        <span v-else>{{ props.row.code }}</span>
      </template>

      <template
        slot="parent"
        slot-scope="props">
        <i
          v-if="props.row.parent == null">No parent tag assigned</i>
        <span v-else>{{ props.row.parent.name }}</span>
      </template>

      <template
        slot="items"
        slot-scope="props">
        <collection-counter
          :collection="props.row.products"
          label="name"
          subject="products assigned" />
      </template>

      <template
        slot="modifier_sets"
        slot-scope="props">
        <collection-counter
          :collection="props.row.modifier_sets"
          label="name"
          subject="modifiers assigned" />
      </template>
    </v-server-table>

    <div
      id="tag-popup"
      class="modal fade inactive"
      data-backdrop="false">
      <div class="right w-xxxl white b-l">
        <vuetabletag_form
          ref="vuetabletag_form"
          :tag="tag"
          @tag-saved="fetchData"
          @showupProduct="showProduct($event)"
        />
      </div>
    </div>

    <div
      id="product-popup"
      class="modal fade inactive"
      data-backdrop="true">
      <product_list
        :tag="tag"
        title="Apply tags to product"
        @updateProduct="updateProduct($event)"
      />
    </div>

  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import CollectionCounter from '@js/components/collection-counter';

const exportUrl = 'franchise.inventory.tags.exportAsFile';

export default {
    components: {
        CollectionCounter,
    },

    data() {
        var that = this;
        let canManageItems = Auth.hasPermissionTo('franchise_manage_items');
        let viewOnlyItems = Auth.hasPermissionTo('admin_view_only_system');

        let actionButtons = [
            {
                title: 'Create Tag',
                action: () => {
                    this.show_popup(null);
                },
            },
        ];

        if (!canManageItems) {
            actionButtons = [];
        }

        if (viewOnlyItems) {
            actionButtons = [];
        }

        return {
            tag: {},
            products: {},
            tableName: 'VUETABLE_TAG',
            api: Laroute.route('franchise.inventory.tags.vue.getvuetabletag'),
            columns: [
                'name',
                'code',
                'parent',
                'items',
                'modifier_sets',
                'available_from',
                'available_to',
            ],
            options: {
                checkbox: canManageItems && !viewOnlyItems,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.tags.delete',
                    ),
                    delete_title: 'Delete Tags',
                },
                sortable: ['name', 'code', 'available_from', 'available_to'],
                orderBy: { column: 'name', ascending: 1 },
                texts: {
                    count:
                        'Showing {from} to {to} of {count} records|{count} records|One record',
                    limit: 'Records per page :',
                    filterPlaceholder: 'Search Tags',
                },
                perPageValues: [5, 10, 20, 40, 80],
                headings: {
                    name: 'Name',
                    parent: 'Parent Tag',
                    items: 'Products',
                    modifier_sets: 'Modifiers',
                },
                csv_url: Laroute.route(exportUrl, { type: 'CSV' }),
                pdf_url: Laroute.route(exportUrl, { type: 'PDF' }),
                actionButtons: actionButtons,

                rowClassCallback: row => {
                    let clazz = ['pointer'];

                    if (row.status == 0) {
                        clazz.push('text-muted');
                    }

                    return clazz;
                },

                rowClickCallback: that.show_popup,
                templates: {
                    available_from(h, row) {
                        return require('./colums/available_from.jsx')(
                            h,
                            row,
                            that,
                        );
                    },
                    available_to(h, row) {
                        return require('./colums/available_to.jsx')(
                            h,
                            row,
                            that,
                        );
                    },
                },
            },
        };
    },

    created() {
        this.init_tag();
    },

    methods: {
        init_tag() {
            this.tag = {
                id: 0,
                name: '',
                code: null,
                parent_id: null,
                description: '',
                products: [],
                modifier_sets: [],
                parent: null,
                hidden_tag: false,
                hidden_products: false,
            };
            // this.$refs.vuetabletag_form.clearTimePicker();
        },

        get_tag(id) {
            var that = this;
            this.$http.get(this.getTagApi(id)).then(response => {
                let data = response.data.data;
                that.tag = data;
                that.$refs.vuetabletag_form.setTimePickerValue(data);
                that.show_modal();
            });
        },

        show_popup(row) {
            if (row != null) {
                this.get_tag(row.id);
            } else {
                this.init_tag();
                this.show_modal();
            }
        },

        show_modal() {
            $('#tag-popup').modal('show');
        },

        showProduct(row) {
            this.data = row;
            this.show_product_modal();
        },

        show_product_modal() {
            $('#product-popup').modal('show');
        },

        updateProduct(row) {
            this.tag.products = row;
        },

        getTagApi(id) {
            return Laroute.route('franchise.inventory.tags.show', { id: id });
        },

        fetchData() {
            this.$refs.datatable.getData();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tag/vuetable_tag.vue